import {useAppDispatch} from '../../redux';
import * as React from 'react';
import {useNavigation} from '@react-navigation/native';
import {useSelector} from 'react-redux';
import {getNewsById} from '../../redux/actions/news';
import {newsByIdSelector} from '../../redux/selectors/news';
import View from './view';
import {Props} from './model';
import {Screens} from '../../shared/routing';

export const NewsArticleScreen = ({route}: Props) => {
  const news = useSelector(newsByIdSelector);
  const navigation = useNavigation();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = React.useState(false);
  const currentIdRef = React.useRef<number | null>(null);

  const navigateToNews = React.useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      (navigation.navigate as any)(Screens.MainTabs, {screen: Screens.News});
    }
  }, [navigation]);

  const routeId = route?.params?.id;

  React.useEffect(() => {
    const id = +(routeId ?? 0);

    if (!Number.isInteger(id)) {
      navigateToNews();
      return;
    }

    // Уже загружена эта статья
    if (id === news?.current?.id) {
      setLoading(false);
      currentIdRef.current = id;
      return;
    }

    // Уже загружаем эту статью
    if (id === currentIdRef.current) {
      return;
    }

    currentIdRef.current = id;
    setLoading(true);

    (async () => {
      try {
        await dispatch(getNewsById(id));
      } catch (error: any) {
        if (currentIdRef.current !== id) return;
        if (error.status === 404) {
          navigateToNews();
        } else {
          throw error;
        }
      } finally {
        if (currentIdRef.current === id) {
          setLoading(false);
        }
      }
    })();
  }, [routeId, navigateToNews, dispatch, news?.current?.id]);

  return View({loading, prevNews: news?.previous, currentNews: news?.current, nextNews: news?.next});
};
